import { connectFela } from '../../dependencies';
import ChangePasswordForm from './ChangePasswordForm';
import * as styles from './ChangePasswordForm.styles';

export default connectFela(styles)(ChangePasswordForm);
